module.exports = __webpack_public_path__ + "static/finance-service-epf-085a04ee7f010f79ff0cf3633d3eef5f.jpg";